import * as AhaComponents from './AhaComponents'

import { version } from '../package.json'

const registerComponent = (Vue, name, def) => {
  if (Vue && name && def) {
    Vue.component(name, def)
  }
}

const registerComponents = (Vue, components = {}) => {
  Object.keys(components).forEach((component) => {
    registerComponent(Vue, component, components[component])
  })
}

function install(Vue) {
  registerComponents(Vue, AhaComponents)
}

export default {
  install,
  version,
}
